var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 13,
    viewBox: "0 0 5 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "formkit:down",
    clipPath: "url(#clip0_46_673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.64275 6.5C4.64332 6.55328 4.63408 6.60611 4.61563 6.65508C4.59717 6.70406 4.56992 6.7481 4.5356 6.78437L1.32132 10.4406C1.17846 10.6031 0.957031 10.6031 0.814174 10.4406C0.671317 10.2781 0.671317 10.0263 0.814174 9.86375L3.77846 6.49187L0.821317 3.12813C0.67846 2.96563 0.67846 2.71375 0.821317 2.55125C0.964174 2.38875 1.1856 2.38875 1.32846 2.55125L4.54275 6.2075C4.61417 6.28875 4.64989 6.39437 4.64989 6.49187L4.64275 6.5Z",
    fill: "#5B5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/rightArrowIcon.3c4da0b157ebf01a61a14aa7c4417915.svg";
export { ForwardRef as ReactComponent };